module.exports = __webpack_public_path__ + "img/background_person.fe57ea30.png";